var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrattoHomeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000108295205954432857650000006016925681749482425_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 277.8 277.8",
    style: {
      enableBackground: "new 0 0 277.8 277.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1111{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-222",
    fill: "black"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "black"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1111",
    d: "M138.9,277.8C62.3,277.8,0,215.5,0,138.9S62.3,0,138.9,0s138.9,62.3,138.9,138.9S215.5,277.8,138.9,277.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M176.2,108.4V97.1H154v4.9c-5.4-3.9-12.2-6.2-19.6-6.2c-18.4,0-32.9,13.8-32.9,32.4c0,7.8,2.6,14.8,6.9,20.3 c0,2.7,0,13.1,0,15c0,1.2,0.2,2.3,0.4,3.5c0.3,1.2,0.8,2.4,1.3,3.4c0.6,1.1,1.4,2.1,2.3,3c0.9,0.9,2.1,1.7,3.4,2.3 c-3.5,2.6-6.2,5.2-7.8,8c-1.7,2.8-2.5,6-2.5,9.6c0,2.9,0.6,5.5,1.9,7.9s3.2,4.4,6,6.2c2.7,1.7,6.2,3.1,10.5,4.1 c4.3,1,9.4,1.5,15.5,1.5c6.4,0,11.9-0.7,16.5-2s8.5-3.2,11.5-5.5c3-2.3,5.2-4.9,6.7-8c1.4-3,2.2-6.2,2.2-9.6 c0-3.1-0.6-5.9-1.9-8.2c-1.3-2.4-3-4.4-5.3-6s-5-2.8-8.1-3.7s-6.6-1.3-10.4-1.4l-19.7-0.8c-3-0.1-5.4-0.8-7.2-2 c-1.8-1.3-2.7-2.8-2.7-4.8c0-1,0.2-2,0.4-2.8c4,1.7,8.5,2.6,13.2,2.6c18.3,0,32.8-14.1,32.8-32.6c0-2.7-0.3-5.3-0.9-7.8v-12 L176.2,108.4L176.2,108.4z M121,185.7c0.6-1.1,1.4-2.1,2.5-3.2c1.1-1.1,2.4-2.1,4.1-3.2l19.6,0.7c5.1,0.2,8.9,1.1,11.4,2.6 c2.5,1.5,3.7,3.7,3.7,6.8c0,1.7-0.4,3.3-1.1,4.9s-2,3-3.7,4.2s-4,2.2-6.8,3c-2.8,0.8-6.3,1.1-10.4,1.1c-6.6,0-11.7-0.8-15.4-2.4 c-3.7-1.6-5.5-4.2-5.5-7.8c0-1.1,0.1-2.2,0.4-3.3S120.4,186.8,121,185.7L121,185.7z M134.4,149.8c-11.9,0-20.9-9.6-20.9-21.6 s9-21.3,20.9-21.3s20.7,9.5,20.7,21.3S146.2,149.8,134.4,149.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M114,64.8h9.8c0,7.1,5,11.3,10.6,11.3S145,71.9,145,64.8h9.8c0,12.5-8.8,20.1-20.4,20.1S114,77.3,114,64.8L114,64.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrattoHomeLogo);
export default __webpack_public_path__ + "static/media/StrattoHomeLogo.7a04685f2c0af0ed7cbc8c6ed1ad57a2.svg";
export { ForwardRef as ReactComponent };